import React from 'react';
import PropTypes from 'prop-types';

// Field-level error line (Claude Design): alert icon + red text under the input.
const PfInlineError = ({ children }) => (
  <span className="pf-inline-error">
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8v4M12 16h.01" />
    </svg>
    <span>{children}</span>
  </span>
);

PfInlineError.propTypes = {
  children: PropTypes.node.isRequired
};

export default PfInlineError;
